export let GetCurrencies = `query GetCurrencies($OperationList:[OperationList]) {
  GetCurrencies(OperationList:$OperationList) {
    CurrencyGuid
    Name
    LanguageGroupGuid
    LanguageGuid
  }
}`;

export let getCurrency = `query SearchCurrency($OperationList: [OperationList]) {
  SearchCurrency(OperationList: $OperationList) {  
      CurrencyGuid
      LanguageGuid
      Name
      LanguageGroupGuid
      ID
      ShortName
      CountryGuid
      Symbol
      Fract
      Basic
      Timestamp
      IsSystemGenerated
  }
}`;

